import { styled, StyledButton, StyledInput } from '@raskrask-dk/rr-components'

export const ResetButton = styled('div', {
    justifySelf: 'end',

    [`& ${StyledButton}`]: {
        fontWeight: 400,
        minH: 0,
        p: 0,

        svg: {
            ml: 4,
            verticalAlign: 'middle',
        },
    },
})

export const StyledAddressReset = styled('div', {
    [`& ${StyledInput}`]: {
        color: '$black',
        fontWeight: 600,
        textAlign: 'center',
    },
})
